import React from "react";
import Konva from "konva";
import {useDispatch, useSelector} from "react-redux";
import {selectZoomState, viewActions} from "./viewSlice";
import {useBaseZoomActions} from "../../../../../base-konva/features/view";
import {selectStageConfig} from "../config/configSlice";

export function useZoomActions() {
	const zoomState = useSelector(selectZoomState);
	const stageConfig = useSelector(selectStageConfig);
	const dispatch = useDispatch();

	const baseActions = useBaseZoomActions({
		zoomState,
		setZoomState: value => {
			dispatch(viewActions.setZoomState(value))
		}
	})

	function handleZoomFitToScreen(stageRef?: React.RefObject<Konva.Stage>) {
		if (stageConfig.width === 0 || stageConfig.height === 0) return
		const fitScale = Math.min(
			zoomState.viewportSize.width / stageConfig.width,
			zoomState.viewportSize.height / stageConfig.height
		)
		const newScale = Math.max(zoomState.minScale, Math.min(fitScale, 1))
		const stage = stageRef?.current
		if (stage) {
			stage.position({
				x: zoomState.viewportSize.width / 2,
				y: zoomState.viewportSize.height / 2,
			})
			stage.batchDraw()
		}
		dispatch(viewActions.setZoomState({...zoomState, scale: newScale}))
	}

	return {...baseActions, handleZoomFitToScreen}
}
